<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3Qa1nv/tc-custom/9781648411465.jpg?1650711003426" alt="This image is the cover for the book Saint Sebastian"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Saint Sebastian
      </h1>
      <p class="bookDescription body article font2">
        <p>After an evening of Dungeons &amp; Dragons doesn’t go as planned, Alex and Matt find themselves with time to explore their mutual nerdy interests and expand the relationship that began in A Study in Charcoal. The two continue to find a balance between sexual and emotional intimacy, rubbing each other wrong and right by turns. Alex introduces Matt to the flamboyant, fem gender expression that he feels most comfortable with, and opens up about his past experiences and the dangers involved with being so visibly queer. Matt considers his sexuality and begins to feel more secure in expressing both affection and attraction. Illustrations, dialogue, and steamy scenes work together to uncover how past violence and having a stigmatized gender expression can affect relationship dynamics. This second story in the series also delves more deeply into how negotiating sexual intimacy can be a pathway to relearning self-love and a capacity to be genuinely vulnerable around others. This high-heat and trauma-informed m/m erotic story is part of Microcosm's Queering Consent series. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicholai Avigdor Melamed
      </h2>
      
      <p class="authorDescription body article">Nicholai is an illustrator by craft and a storyteller by compulsion. His work is an ongoing exploration of resilience at the crossroads of queer, trans identity and immigrant experiences within an ethnoreligious diaspora. He has appeared in numerous anthologies, including Shout Out and Invisible Illness.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6efaffa8